import React from 'react';
import { useNavigate } from 'react-router-dom';
import BgImage from '../../assets/backgroundImage.png';
import Pagination from '../Pagination';
import Title from '../Title';
import { BeatLoader } from 'react-spinners';
import useUserManagement from '../../hooks/UserManagement/useUserManagement';

const UserGrid = () => {
  const navigate = useNavigate();
  const { paginatedPeople, totalEntries, isLoading } = useUserManagement();

  if (isLoading) {
    return (
      <div className="p-4 h-screen bg-[#F4F5F6] flex justify-center items-center">
        <BeatLoader data-testid="beat-loader" color="#000000" size={15} role="status" />
      </div>
    );
  }

  return (
    <>
      <div className="pb-4 my-2">
        <Title title="User Management" subtitle="Home &gt; User Grid" />
      </div>
      <div className="grid grid-cols-4 gap-2 mt-8">
        {paginatedPeople.map(user => {
          const fallbackImage =
            'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';

          const profileImage =
            user?.profilePictureUrl && user.profilePictureUrl.trim() !== ''
              ? user.profilePictureUrl
              : fallbackImage;

          return (
            <button
              key={user._id}
              className="relative flex flex-col items-center justify-between h-64 mb-6 overflow-hidden transition-transform bg-white shadow-sm cursor-pointer w-52 rounded-2xl hover:scale-105"
              onClick={() => navigate(`${user._id}`)}
              aria-label={`View ${user.firstName} ${user.lastName}'s profile`}
              style={{
                backgroundImage: `url(${BgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}>
              <div className="absolute z-10 top-4 right-4">
                <span className="bg-[#E6FBF3] text-[#00C080] text-xs font-medium px-2 py-1.5 rounded-full">
                  Active
                </span>
              </div>

              <div className="mt-8">
                <img
                  className="object-cover w-20 h-20 rounded-full"
                  src={profileImage}
                  alt={`${user.firstName} ${user.lastName}`}
                />
              </div>
              <div className="w-full px-8 py-6 text-center bg-white/90 backdrop-blur-sm">
                <h3 className="text-sm font-semibold text-[#1f2937]">
                  {user.firstName || '-'} {user.lastName || ''}
                </h3>
                <p className="text-sm font-medium text-[#6b7280] mt-1">
                  {user.title || 'No title'}
                </p>
                <p className="text-xs text-[#9ca3af] mt-3 truncate max-w-full">
                  {user.email || '-'}
                </p>
              </div>
            </button>
          );
        })}
      </div>
      <Pagination totalEntries={totalEntries} />
    </>
  );
};

export default UserGrid;
